import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BaseComponent } from './views/layout/base/base.component';
import { ErrorPageComponent } from './views/modules/error-page/error-page.component';

//guards
import { AuthGuard } from './guards/auth.guard';
import { SelectClinicGuard } from './guards/select-clinic/select-clinic.guard';

//local storage
import { NgxsModule } from '@ngxs/store'
import { SessionState } from './services/state/session.state';

import { RouterClass } from './services/utils/router/router-class.routes';



const routes: Routes = [
  {
    path: RouterClass.routes.AUTH,
    loadChildren: () =>
      import('./views/modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'attendance',
    canActivate: [AuthGuard, SelectClinicGuard],
    loadChildren: () =>
      import('./views/modules/attendance/attendance.module').then(m => m.AttendanceModule)
  },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: RouterClass.routes.SELECT_CLINIC,
        loadChildren: () =>
          import('./views/modules/select-company/select-company.module').then(m => m.SelectCompanyModule)
      },
      // {
      //   path: 'dashboard',
      //   loadChildren: () =>
      //     import('./views/modules/dashboard/dashboard.module').then(m => m.DashboardModule),
      //   canActivate: [SelectClinicGuard]
      // },
      {
        path: RouterClass.routes.HOME,
        loadChildren: () =>
          import('./views/modules/home/home.module').then(m => m.HomeModule),
        canActivate: [SelectClinicGuard]
      },
      {
        path: RouterClass.routes.PROFILE,
        loadChildren: () =>
          import('./views/modules/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [SelectClinicGuard]
      },
      {
        path: RouterClass.routes.SETTINGS,
        loadChildren: () =>
          import('./views/modules/settings/settings.module').then(m => m.SettingsModule),
        canActivate: [SelectClinicGuard]
      },
      {
        path: RouterClass.routes.EMPLOYEES,
        loadChildren: () =>
          import('./views/modules/employee/employees.module').then(m => m.EmployeesModule),
        canActivate: [SelectClinicGuard]
      },
      {
        path: RouterClass.routes.PATIENTS,
        loadChildren: () =>
          import('./views/modules/patient/patient.module').then(m => m.PatientModule),
        canActivate: [SelectClinicGuard]
      },
      {
        path: RouterClass.routes.SCHEDULES,
        loadChildren: () =>
          import('./views/modules/schedule/schedule.module').then(m => m.ScheduleModule),
        canActivate: [SelectClinicGuard]
      },
      {
        path: RouterClass.routes.DATASHEETS,
        loadChildren: () =>
          import('./views/modules/pep/pep.module').then(m => m.PepModule),
        canActivate: [SelectClinicGuard]
      },
      {
        path: RouterClass.routes.PROCEDURES,
        loadChildren: () =>
          import('./views/modules/procedures/procedures.module').then(m => m.ProceduresModule),
        canActivate: [SelectClinicGuard]
      },
      {
        path: RouterClass.routes.INSURANCES,
        loadChildren: () =>
          import('./views/modules/insurances/insurances.module').then(m => m.InsurancesModule),
        canActivate: [SelectClinicGuard]
      },
      {
        path: 'room',
        loadChildren: () =>
          import('./views/modules/room/room.module').then(m => m.RoomModule),
        canActivate: [SelectClinicGuard]
      },
      {
        path: '',
        redirectTo: RouterClass.routes.HOME,
        pathMatch: 'full'
      },
      {
        path: RouterClass.routes.CALENDAR,
        loadChildren: () =>
          import('./views/modules/calendar/calendar.module').then(m => m.CalendarxModule),
        canActivate: [SelectClinicGuard]
      },
    ]
  },
  {
    path: 'error/:type',
    component: ErrorPageComponent
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' }),
    NgxsModule.forRoot([SessionState])
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
